import { Grid } from "@mui/material";

import Paper from "../../../components/Paper";
import TextField from "../../../components/TextField";
import ComponentHeader from "../../../components/ComponentHeader";

export default function FormDisplay({ formikProps }) {
  return (
    <Paper>
      <Grid item xs={12}>
        <ComponentHeader
          title={"Workflow Details"}
          subtitle={"Details of workflow"}
        />
      </Grid>

      <Grid item xs={4}>
        <TextField
          name="workflowName"
          label="Workflow Name"
          formikProps={formikProps}
          disabled
        />
      </Grid>

      <Grid item xs={8}>
        <TextField
          name="workflowDescription"
          label="Workflow Description"
          formikProps={formikProps}
          disabled
        />
      </Grid>
    </Paper>
  );
}
